export default __webpack_public_path__ + "static/media/ImportUsers.fdc6af44.xlsx";